import _ from 'lodash';
import store from './store';
import { isObjectNotEmpty } from './tools'
import { updateMenuPosition } from '../apis/backend'

export const getFirstProductCategory = product => {
  const { categories } = product;
  let firstCategory = null;
  const shopCategories = store.getState().firebaseRealTime.menu?.categories;

  if (categories) {
    const productCategories = categories.split(',');
    const categoryKey = productCategories[0].split('@')[0];
    firstCategory = shopCategories?.[categoryKey];
  }
  return firstCategory;
}

export const sortItemsPositionForShop = async (event, items, itemKey, isCatgory, isProduct) => {
  const { active = {}, over = {} } = event;
  const positionUpdates = {};
  const oldIndex = _.findIndex(_.keys(items), elt => elt === active.id);
  const newIndex = _.findIndex(_.keys(items), elt => elt === over.id);

  Object.keys(items).slice(
    oldIndex > newIndex ? newIndex : oldIndex,
    (oldIndex > newIndex ? oldIndex : newIndex) + 1
  ).forEach(key => {
    const item = items[key];
    const { position: initialPos } = item;
    if (initialPos === oldIndex) item.position = newIndex;
    else if (oldIndex < initialPos && initialPos <= newIndex && oldIndex < newIndex)
      item.position = initialPos - 1;
    else if (newIndex <= initialPos && initialPos < oldIndex && oldIndex > newIndex)
      item.position = initialPos + 1;

    if (initialPos !== item.position) {
      positionUpdates[key] = { position: item.position }
    }
  })

  if (isObjectNotEmpty(positionUpdates)) {
    const positions = isCatgory ? { categories: { [itemKey]: { items: positionUpdates } } } : isProduct ? { sections: { [itemKey]: { products: positionUpdates } } } : { sections: positionUpdates }
    await updateMenuPosition(positions)

  }

}

export const returnCategories = (categories = {}, allCategories) => {
  let categoriesToArray = [];
  const returnArray = [];
  if (typeof categories === 'string') {
    categoriesToArray = categories.includes(',') ? categories.split(',') : [categories];
    _.forEach(categoriesToArray, categoryKey => {
      if (allCategories && allCategories[categoryKey]) {
        const { name = '', type = null } = allCategories[categoryKey];
        returnArray.push({
          name,
          key: categoryKey,
          type
        });
      }
    });
  }

  return returnArray;
}
export const getOriginalCategories = (items, ref, allCategories, isIngType) => {
  let originalCategories = [];
  _.entries(items).forEach(([itemKey, item]) => {
    const { products = {}, items } = item;
    const itemsToCheck = isIngType ? items : products;

    const originalItem = _.values(itemsToCheck).filter(item => item.ref === ref);
    if (originalItem?.length > 0) {
      const categoriesToCheck = isIngType ? originalItem[0]?.subcategories : originalItem[0]?.categories;
      originalCategories = returnCategories(categoriesToCheck, allCategories);
    }

  });

  return originalCategories;
};
export const getCopyName = (key, name) =>
  key.includes('copy') ? `${name} (copie)` : name;

export const setCopyKey = (key) => `${key}copy`;
